var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSafetyBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_313_2748",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_313_2748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.89769 16.9999H5.13087V15.5392H6.66476V16.1981L5.89769 16.9999Z",
    fill: "#2F6086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.092 16.9664H14.8588V15.5057H13.3252V16.1646L14.092 16.9664Z",
    fill: "#2F6086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1488 16.0624H4.73146C4.44889 16.0624 4.21967 15.8332 4.21967 15.5506V4.05805C4.21967 3.77549 4.44889 3.54651 4.73146 3.54651H15.1488C15.4314 3.54651 15.6606 3.77573 15.6606 4.0583V15.5509C15.6606 15.8332 15.4317 16.0624 15.1488 16.0624Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.709 14.9967H5.1713C5.11896 14.9967 5.07654 14.9543 5.07654 14.9019V4.70683C5.07654 4.65448 5.11896 4.61206 5.1713 4.61206H14.709C14.7613 4.61206 14.8038 4.65448 14.8038 4.70683V14.9019C14.8038 14.9543 14.7613 14.9967 14.709 14.9967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4222 16.5231L5.18993 15.0465C5.15371 15.0401 5.12419 14.9912 5.12419 14.9374V4.78743C5.12419 4.73359 5.15346 4.68472 5.18993 4.67827L13.4222 3.20145C13.4823 3.19078 13.5311 3.23817 13.5311 3.30788V16.4167C13.5311 16.4861 13.4823 16.5338 13.4222 16.5231Z",
    fill: "#2F6086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2153 9.86217C11.2153 11.4767 10.1818 12.699 8.9883 12.599C7.8759 12.506 7.02821 11.2829 7.02821 9.86217C7.02821 8.44117 7.8759 7.21838 8.9883 7.12535C10.1821 7.02537 11.2153 8.24791 11.2153 9.86217Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6765 9.86222C10.6765 11.086 9.89973 12.028 8.98853 11.9692C8.12546 11.9136 7.45862 10.9714 7.45862 9.86222C7.45862 8.75305 8.12546 7.81084 8.98853 7.75527C9.89973 7.69673 10.6765 8.63869 10.6765 9.86222Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55913 9.86214C9.55913 10.2759 9.30113 10.6056 8.9883 10.5984C8.68142 10.5915 8.43681 10.2618 8.43681 9.86214C8.43681 9.46249 8.68142 9.13254 8.9883 9.12584C9.30137 9.11889 9.55913 9.44834 9.55913 9.86214Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M9.44003 9.39575C9.4899 9.50565 9.51892 9.63416 9.51892 9.77184C9.51892 10.1851 9.26167 10.5151 8.94958 10.5089C8.77369 10.5054 8.61864 10.3955 8.51842 10.2281C8.61318 10.4451 8.79056 10.5942 8.99597 10.5989C9.3088 10.6059 9.56705 10.2762 9.56705 9.86239C9.56705 9.68501 9.51942 9.52277 9.44003 9.39575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03419 11.9309C9.03419 11.7748 9.03419 11.619 9.03419 11.463C9.03419 11.3985 8.95778 11.3948 8.95778 11.4593C8.95778 11.6148 8.95778 11.7706 8.95778 11.9262C8.95803 11.9904 9.03419 11.9954 9.03419 11.9309Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03423 8.26156C9.03423 8.10551 9.03423 7.94972 9.03423 7.79367C9.03423 7.72917 8.95782 7.73414 8.95782 7.79839C8.95782 7.95393 8.95782 8.10973 8.95782 8.26528C8.95807 8.32978 9.03423 8.3263 9.03423 8.26156Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4874 9.92966C7.59581 9.92916 7.70497 9.92867 7.81487 9.92817C7.86051 9.92792 7.86026 9.83117 7.81462 9.83167C7.70472 9.83266 7.59556 9.8334 7.48715 9.8344C7.44225 9.83464 7.44274 9.92991 7.4874 9.92966Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2535 9.91625C10.382 9.91551 10.5115 9.91501 10.642 9.91427C10.6963 9.91402 10.6958 9.80859 10.6415 9.80908C10.511 9.81008 10.3815 9.81107 10.253 9.81206C10.2002 9.81256 10.2004 9.9165 10.2535 9.91625Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96172 11.3515C8.03888 11.2458 8.11628 11.1396 8.19417 11.033C8.22642 10.9886 8.17408 10.9194 8.14183 10.9638C8.06418 11.0704 7.98703 11.1766 7.91012 11.2823C7.87862 11.3257 7.92997 11.3952 7.96172 11.3515Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88138 8.72121C9.96821 8.60238 10.0553 8.48281 10.1431 8.36274C10.1796 8.31287 10.1205 8.24391 10.0841 8.29377C9.99674 8.41384 9.90991 8.53341 9.82333 8.65225C9.78761 8.70136 9.84541 8.77033 9.88138 8.72121Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96493 8.38841C8.03787 8.49955 8.11105 8.61119 8.18448 8.72332C8.215 8.76996 8.27032 8.70422 8.23956 8.65758C8.16563 8.54544 8.0922 8.43381 8.01926 8.32242C7.989 8.27653 7.93492 8.34251 7.96493 8.38841Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7732 11.1456C9.85457 11.2699 9.93644 11.3946 10.0188 11.5199C10.053 11.572 10.1148 11.5075 10.0803 11.4554C9.99771 11.3299 9.9156 11.2051 9.83398 11.0808C9.80024 11.0297 9.73946 11.0942 9.7732 11.1456Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3064 12.1639L12.3024 12.1636C12.2238 12.1587 12.1602 12.0785 12.1602 11.985V7.83339C12.1602 7.73987 12.2238 7.65999 12.3024 7.65527L12.3064 7.65502C12.3855 7.65006 12.4498 7.72275 12.4498 7.81702V12.0024C12.4498 12.0967 12.3855 12.1691 12.3064 12.1639Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6341 16.5246H13.4222V3.20142H13.6341C13.6619 3.20142 13.6844 3.22399 13.6844 3.25178V16.474C13.6844 16.502 13.6619 16.5246 13.6341 16.5246Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49679 7.35654V6.66068C5.49679 6.48107 5.35116 6.33569 5.1718 6.33569C4.99244 6.33569 4.84682 6.48132 4.84682 6.66068V7.3563H5.49679V7.35654Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84657 7.44751V8.14313C4.84657 8.32274 4.9922 8.46811 5.17156 8.46811C5.35092 8.46811 5.49654 8.32249 5.49654 8.14313V7.44751H4.84657Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41442 12.0553V11.3597C5.41442 11.18 5.2688 11.0347 5.08944 11.0347C4.91007 11.0347 4.76445 11.1803 4.76445 11.3597V12.0553H5.41442Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76421 12.1462V12.8419C4.76421 13.0215 4.90983 13.1668 5.08919 13.1668C5.26855 13.1668 5.41418 13.0212 5.41418 12.8419V12.1462H4.76421Z",
    fill: "#2C3A64"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSafetyBox);
export default __webpack_public_path__ + "static/media/icon-safety-box.d5530dc4ce7d3d6938f30c0b2f448311.svg";
export { ForwardRef as ReactComponent };